import { render, staticRenderFns } from "./LayoutCompact.vue?vue&type=template&id=6a18e660&"
import script from "./LayoutCompact.vue?vue&type=script&lang=ts&"
export * from "./LayoutCompact.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports